import TreeNodeRenderer from './TreeNodeRenderer'
import NodeContentRenderer from './NodeContentRenderer'

const theme = {
  scaffoldBlockPxWidth: 25,
  treeNodeRenderer: TreeNodeRenderer,
  nodeContentRenderer: NodeContentRenderer
}

export default theme
